import * as React from "react";
import { useTranslation } from "react-i18next";
import { BookStatsInline } from "../common";
import bookStatsData from "../../data/book_stats.json";

interface BookDescriptionProps {
  className?: string;
  /**
   * The subtitle ships with the description because every existing caller wants
   * both. /checkout puts the subtitle directly under the title instead, where
   * it belongs, and turns this off so it is not printed twice.
   */
  showSubtitle?: boolean;
}

const bookStatsInline = {
  total_chapters: bookStatsData.aggregate.total_chapters,
  total_code_blocks: bookStatsData.aggregate.total_code_blocks,
  total_figures: bookStatsData.aggregate.total_figures,
};

const BookDescription: React.FC<BookDescriptionProps> = ({
  className = "tmb-3",
  showSubtitle = true,
}) => {
  const { t } = useTranslation("home");

  // Parse the description to replace <author> tags with actual links
  const renderDescription = () => {
    const description = t("hero.description");
    const parts = description.split(/<author>(.*?)<\/author>/);

    return parts.map((part, index) => {
      // Odd indices are the author names (between <author> tags)
      if (index % 2 === 1) {
        return (
          <a
            key={index}
            href="https://victordibia.com"
            target="_blank"
            rel="noreferrer"
            className="text-accent font-semibold hover:underline"
          >
            {part}
          </a>
        );
      }
      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  };

  return (
    <div className={className}>
      {showSubtitle && (
        <div className="text-xl text-secondary mb-3">{t("hero.subtitle")}</div>
      )}

      <div className="mt-4 text-base text-secondary">
        {renderDescription()}{" "}
        <BookStatsInline stats={bookStatsInline} />
      </div>
    </div>
  );
};

export default BookDescription;
